export default __webpack_public_path__ + "static/media/Machinery Blue.8bbf54b9.png";